import React, { FC, useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router';

import Button from 'devextreme-react/button';
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
//devextreme
import { TextBox } from 'devextreme-react/text-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { NumberBox, SelectBox, TextArea } from 'devextreme-react';
import { isSuccess } from 'utils/responseStatus';

import { useGetContractorDetailInfoQuery, useLazyGetContractorDetailInfoQuery } from 'bus/contractor/services/services';
import {
  useChangeContractorObjectMutation,
  useCreateContractorObjectMutation,
  useGetContractorObjectLocationsQuery,
  useGetContractorObjectTypesQuery,
  useLazyGetContractorObjectDetailQuery,
} from 'bus/contractorObject/services';
import { ContractorObjectItem } from 'bus/contractorObject/types';
import { TemplateSalaryItem } from 'bus/templateSalary/types';

type DetailModalRoleProps = {
  id: number | null;
  parentId: number | null;
  refresh: () => void;
  addRoot?: boolean;
  createForTask?: boolean;
  contractorIdTaskForm?: number | string; //если открыли форму из страницы создания заявки
  templateSalary: TemplateSalaryItem[];
};

const initialForm = {
  id: null,
  contractorId: null,
  parentId: null,
  type: null,
  address: '',
  comment: '',
  residentSalary: 0,
  nonResidentSalary: 0,
  fault: 0,
  location: 0,
};

const DetailModalObject: FC<DetailModalRoleProps> = ({
  id: objectId,
  parentId,
  addRoot,
  contractorIdTaskForm,
  refresh,
  //templateSalary = [],
}) => {
  let { id } = useParams<{ id: string }>();

  const [getContractorDetailInfo] = useLazyGetContractorDetailInfoQuery();
  const { data: contractorObjectTypesData } = useGetContractorObjectTypesQuery();
  const { data: contractorObjectLocations } = useGetContractorObjectLocationsQuery();
  const [getContractorObjectDetail] = useLazyGetContractorObjectDetailQuery();
  const [createContractorObject, { isLoading: isLoadingCreate }] = useCreateContractorObjectMutation();
  const [changeContractorObject, { isLoading: isLoadingChange }] = useChangeContractorObjectMutation();

  let createCatalogGroupRef = useRef<Form | null>(null);
  let createCatalogGroupValidationRef = useRef<any>(null);

  const [form, setForm] = useState<ContractorObjectItem>(initialForm);
  const [visibleModal, setVisibleModal] = useState<boolean>(false);
  const [visibleModalAdd, setVisibleModalAdd] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault && e.preventDefault();
    if (createCatalogGroupValidationRef.current?.instance.validate().isValid) {
      //если форма открыта через кнопку редактировать
      if (objectId !== null && visibleModal) {
        await changeContractorObject({
          ...form,
          //если открыли форму из страницы создания заявки
          contractorId: contractorIdTaskForm ? contractorIdTaskForm : id,
        });
      } else {
        await createContractorObject({
          ...form,
          id: 0,
          //если открыли форму из страницы создания заявки
          contractorId: contractorIdTaskForm ? contractorIdTaskForm : id,
          //если нажали кнопку добавить берем индвификтор текущего поля, иначе parendId
          parentId: visibleModalAdd ? objectId : parentId,
        });
      }

      setVisibleModal(false);
      setVisibleModalAdd(false);
      refresh();
    }
  };

  const resetForm = () => {
    setForm({ ...initialForm });
    createCatalogGroupRef.current?.instance.resetValues();
    createCatalogGroupValidationRef.current.instance.reset();
  };

  const onHidden = () => {
    resetForm();
  };

  const getTypes = useMemo(() => {
    return contractorObjectTypesData?.filter((item) => item.id < 2);
  }, [contractorObjectTypesData]);

  const showAddModal = () => {
    setVisibleModalAdd(true);

    getContractorDetailInfo({ id }).then((data) => {
      if (isSuccess(data)) {
        setForm((prev) => ({ ...prev, location: data.data?.locationType || 0 }));
      }
    });
  };

  const showEditModal = async () => {
    if (objectId) {
      await getContractorObjectDetail({ id: objectId }).unwrap().then(setForm);
    }
    setVisibleModal(true);
  };

  const showModalHandler = () => {
    if (addRoot) {
      showAddModal();
    } else {
      showEditModal();
    }
  };

  const onHidingHandler = () => {
    resetForm();
    setTimeout(() => {
      setVisibleModal(false);
      setVisibleModalAdd(false);
    }, 10);
  };

  const isLoading = isLoadingCreate || isLoadingChange;

  return (
    <div>
      <Button
        text={addRoot ? 'Добавить' : undefined}
        icon={addRoot ? undefined : 'edit'}
        type="normal"
        stylingMode="text"
        onClick={showModalHandler}
      />

      <Popup
        visible={visibleModal || visibleModalAdd}
        onHiding={onHidingHandler}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Объекты"
        width={700}
        onHidden={onHidden}
        height="auto"
        deferRendering
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit} action="add-edit-object">
              <ValidationGroup ref={createCatalogGroupValidationRef}>
                <Form formData={form} ref={createCatalogGroupRef}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Наименование объекта" labelTop>
                          <TextBox
                            stylingMode="underlined"
                            placeholder="Введите наименование объекта"
                            mode="text"
                            value={form.address}
                            onChange={(e: any) => {
                              setForm((prev) => ({ ...prev, address: e.event.currentTarget.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле наименование объекта" />
                            </Validator>
                          </TextBox>
                        </AppFiledBox>

                        <AppFiledBox label="Тип" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            placeholder="Выберите тип"
                            mode="text"
                            value={form.type}
                            onValueChange={(e) => {
                              setForm((prev) => ({ ...prev, type: e }));
                            }}
                            displayExpr="name"
                            valueExpr="id"
                            dataSource={getTypes}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле тип" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>

                        <AppFiledBox label="Местность" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            placeholder="Выберите местность"
                            mode="text"
                            value={form.location}
                            onValueChange={(e) => {
                              setForm((prev) => ({ ...prev, location: e }));
                            }}
                            displayExpr="name"
                            valueExpr="id"
                            dataSource={contractorObjectLocations}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле местность" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>

                        <AppFiledBox label="Оплата запчастей" labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="Введите Оплата запчастей"
                            //mode="number"
                            format="###0.##"
                            value={form.fault}
                            onValueChanged={(e) => {
                              setForm((prev) => ({ ...prev, fault: e.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Оплата запчастей" />
                            </Validator>
                          </NumberBox>
                        </AppFiledBox>

                        <AppFiledBox label="Комментарий" labelTop>
                          <TextArea
                            stylingMode="underlined"
                            placeholder="Введите комментарий"
                            mode="text"
                            value={form.comment}
                            onChange={(e: any) => {
                              setForm((prev) => ({ ...prev, comment: e.event.currentTarget.value }));
                            }}
                          ></TextArea>
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  disabledSubmit={isLoading}
                  hideModal={() => {
                    resetForm();

                    setTimeout(() => {
                      setVisibleModal(false);
                      setVisibleModalAdd(false);
                    }, 100);
                  }}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default DetailModalObject;
